/**
 * Get Invoice Display Status Utility
 * Determines the correct status to display based on payment summary and invoice status
 * This ensures that invoices with paymentSummary.isPaid=true show as "paid" even if status is "sent"
 */

/**
 * Get the display status for an invoice
 * Priority: paid > partial > stored status
 * @param {Object} invoice - Invoice object
 * @returns {string} Display status ("draft", "sent", "paid", "partial", "overdue", "cancelled")
 */
export const getInvoiceDisplayStatus = (invoice) => {
  if (!invoice) return "draft";

  const status = invoice.status || "draft";
  const total = Number(invoice.total || 0);
  const paymentSummary = invoice.paymentSummary || {};
  const totalPaid = Number(paymentSummary.totalPaid || 0);

  // If cancelled, always show cancelled
  if (status === "cancelled") {
    return "cancelled";
  }

  // ✅ Keep draft/pending as editable states.
  // Otherwise 0-total invoices (or invoices with paymentSummary) can be incorrectly treated as "paid"/"partial",
  // which hides the Edit button and blocks the intended "revise → edit" workflow.
  if (status === "draft" || status === "pending") {
    return status;
  }

  // Check if fully paid (priority check)
  if (paymentSummary.isPaid || (total > 0 && totalPaid >= total)) {
    return "paid";
  }

  // Check if partially paid
  if (
    paymentSummary.isPartial ||
    (totalPaid > 0 && (total === 0 || totalPaid < total))
  ) {
    return "partial";
  }

  // Otherwise return the stored status
  return status;
};

